<template lang="pug">
section.section.classes
  .section-separator
    h3 {{ $t("classes.title") }}

    .classes__slider.slider(v-if="isSliderReady")
      ClassesPagination(
        :selectedArchetype="selected_archetype",
        :selectedClass="selected_class",
        :classesList="classes",
        @selectArchetype="selectArchetype",
        @selectClass="selectClass"
      )

      swiper(ref="swiper_classes", :options="swiper_setting")
        swiperSlide(
          v-for="(item, id) in classesList",
          :key="`class-${id}`"
          :data-class="id"
        )
          .slider__image
            img(:src="getImagePath(id)")
          .slider__content
            h4.slider-title(v-html="item.title")
            p {{ item.description }}

      .arrow.dir--prev
      .arrow.dir--next
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

import ClassesPagination from "./ClassesPagination.vue";

export default {
  name: "Classes",

  components: {
    swiper,
    swiperSlide,
    ClassesPagination,
  },

  data() {
    return {
      classes: {
        warrior: ["berserker", "destroyer", "warlord", "slayer", "paladin"],
        shooter: ["gunslinger", "devilhunter", "hawkeye", "blaster", "scout"],
        magician: ["sorceress", "arcana", "summoner", "bard"],
        assassin: ["blades", "reaper", "demonic", "souleater"],
        monk: ["lancemaster", "striker", "soulmaster", "infighter", "battlemaster", "breaker"],
        creator: ["aeromancer", "artist", "wildsoul"],
      },
      selected_archetype: null,
      selected_class: null,
      initial_class: "wildsoul", // setting for choose slider initial slide
      indexOfSelectedClass: 0,

      swiper_setting: {
        initialSlide: 0,
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        effect: "fade",
        fade: {
          crossFade: true,
        },
        speed: 600,
        spaceBetween: 0,
        navigation: {
          prevEl: ".classes__slider .dir--prev",
          nextEl: ".classes__slider .dir--next",
        },
        on: {
          slideChange: () => {
            this.slideChange();
          },
        },
      },
    };
  },

  computed: {
    classesList() {
      const ordered_list = {};
      const list = this.$t("classes.list");

      Object.values(this.classes).forEach(classes => {
        classes.forEach(subclass => {
          ordered_list[subclass] = list[subclass];
        });
      });

      return ordered_list;
    },

    classesIds() {
      return Object.keys(this.classesList);
    },

    isSliderReady() {
      return this.selected_archetype && this.selected_class;
    },
  },

  mounted() {
    this.swiper_setting.initialSlide = this.chooseSlideIndex(this.classes, this.initial_class);

    this.selected_archetype = this.findKeyIndex(this.classes, this.initial_class);

    if (this.initial_class)
      this.indexOfSelectedClass = this.classes[this.selected_archetype].indexOf(this.initial_class);

    this.selected_class = this.classes[this.selected_archetype][this.indexOfSelectedClass];
  },

  methods: {
    getImagePath(id) {
      return require(`@/assets/images/classes/${id}.png`);
    },

    chooseSlideIndex(data, element) {
      let globalIndex = 0;

      for (const key in data) {
        const currentArray = data[key];
        for (const item of currentArray) {
          if (item === element) {
            return globalIndex;
          }
          globalIndex++;
        }
      }

      console.info("There is no such class"); // report to console - don't delete
      this.initial_class = 0;

      return 0;
    },

    findKeyIndex(data, element) {
      for (const key in data) {
        const currentArray = data[key];
        if (currentArray.length > 0 && currentArray.includes(element)) {
          return key;
        }
      }

      return Object.keys(data)[0];
    },

    selectArchetype(name) {
      if (name !== this.selected_archetype) {
        this.selected_archetype = name;
        this.selected_class = this.classes[name][0];
        this.sliderShowSlide();
      }
    },

    selectClass(name) {
      if (name !== this.selected_class) {
        this.selected_class = name;
        this.selected_archetype = this.getSelectedArchetype(name);
        this.sliderShowSlide();
      }
    },

    slideChange() {
      const slide_index = this.$refs.swiper_classes.swiper.realIndex;
      const selected_class = this.classesIds[slide_index];
      const selected_archetype = this.getSelectedArchetype(selected_class);

      if (selected_archetype !== this.selected_archetype) this.selectArchetype(selected_archetype);
      if (selected_class !== this.selected_class) this.selectClass(selected_class);
    },

    getSelectedArchetype(target_class) {
      return Object.keys(this.classes).find(key => this.classes[key].includes(target_class));
    },

    sliderShowSlide() {
      const active_index = this.classesIds.indexOf(this.selected_class);
      this.$refs.swiper_classes.swiper.slideTo(active_index + 1);
    },
  },
};
</script>
